import { useNavigate } from "react-router-dom";
import { APP_NAME } from "../constants/info";
import appLogo from "../images/app-logo.png";

type AppLogoProps = {
  className?: string;
  showAppName?: boolean;
};

const AppLogo: React.FC<AppLogoProps> = ({
  className = "",
  showAppName = false,
}) => {
  const navigate = useNavigate();
  return (
    <div className="justify-center items-center">
      <div
        className="flex flex-col cursor-pointer"
        onClick={() => navigate("/")}
      >
        <div
          className={`bg-transparent p-1 items-center justify-center ${className}`}
        >
          <img src={appLogo} alt={APP_NAME} className="app-logo" />
        </div>
        {showAppName && (
          <span className="mt-4 logo-text text-xl sm:text-2xl">{APP_NAME}</span>
        )}
      </div>
    </div>
  );
};

export default AppLogo;
